export default __webpack_public_path__ + "static/ENSALADA-e4d205a45cfdb537149027985166ab73.jpg";